import { FC } from 'react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import IconButton from '../../../form/elements/IconButton';

interface DataGridActionTemplateProps {
  onClick: () => void;
}

const DataGridActionTemplate: FC<DataGridActionTemplateProps> = (props) => {
  return <IconButton icon={faTrash} onClick={props.onClick} />;
};

export default DataGridActionTemplate;
